import * as apiContract from '@/api/contract'
import { commonErrorMessage } from '@/util/common'
import * as _ from 'lodash'

const getDefaultState = () => {
  const defaults = {
    products: [],
    charge_name: null,
    data: {},
    visiblePopup: null
  }
  return defaults
}

const trial = {
  namespaced: true,
  state: getDefaultState(),
  getters: {},
  mutations: {
    setLists(state, products) {
      state.products = products
    },
    setChargeName(state, name) {
      state.charge_name = name
    },
    resetAll(state) {
      Object.assign(state, getDefaultState())
    },
    setPurchaseConfirm(state, data) {
      state.data = data
    },
    setVisiblePopup(state, value) {
      state.visiblePopup = value
    }
  },
  actions: {
    confirm: async({ commit, state }, obj) => {
      const { products, chargeName } = obj
      await commit('setLists', products)
      chargeName && await commit('setChargeName', chargeName)

      // APIに購入確認ステータスでリクエスト
      const params = {
        type: 1, // 購入確認
        data: _.map(state.products, code => {
          return {
            code: code,
            num: 1
          }
        }),
        charge_name: state.charge_name
      }


      await apiContract
        .applyProducts(params)
        .then((response) => {
          const { data } = response
          if (data.status === 0) {
            commit('setPurchaseConfirm', data)
            commit('setVisiblePopup', 'confirm')
          } else {
            commonErrorMessage(response)
          }
          return data
        })
    },
    complete: async({ commit, state }) => {
      // APIに購入確認ステータスでリクエスト
      const params = {
        type: 2, // 購入完了
        data: _.map(state.products, code => {
          return {
            code: code,
            num: 1
          }
        }),
        charge_name: state.charge_name
      }
      await apiContract
        .applyProducts(params)
        .then((response) => {
          const { data } = response
          if (data.status === 0) {
            commit('setPurchaseConfirm', data)
            commit('setVisiblePopup', 'complete')
          } else {
            commonErrorMessage(response)
          }
          return data
        })
    },
    close: ({ commit }) => {
      commit('resetAll')
    }
  }
}

export default trial
